import { AuthenticationResult, InteractionRequiredAuthError, IPublicClientApplication, PopupRequest } from "@azure/msal-browser";
import { InternalAxiosRequestConfig } from 'axios';
import { useStore } from '../../index';

async function setAuthorizationHeader(config: InternalAxiosRequestConfig, response: AuthenticationResult) {
    config.headers.Authorization = `Bearer ${response.accessToken}`;
    useStore.getState().setAccessToken(response.accessToken);
    return config;
}

function axiosMiddleware(config: InternalAxiosRequestConfig, msalInstance: IPublicClientApplication) {
    return (async (config) => {
        if (!msalInstance) throw new Error("MSAL instance not initialized");
        let response: AuthenticationResult;
        
        // Get scope from Zustand store
        const scope = useStore.getState().auth.scope;
        const loginRequest: PopupRequest = {
            scopes: scope ? [scope] : [],
            prompt: "select_account",
        };
        const silentRequest: PopupRequest = {
            scopes: scope ? [scope] : [],
        };

        try {
            response = await msalInstance.acquireTokenSilent(silentRequest);
            await setAuthorizationHeader(config, response);
        } catch(e) {
            if (e instanceof InteractionRequiredAuthError) {
                response = await msalInstance.acquireTokenPopup(loginRequest)
                await setAuthorizationHeader(config, response);
            }
        }
        return config;
    })(config);
}

export default axiosMiddleware;